import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { injectIntl } from "react-intl";
import { Box, Button, Typography, Stack } from "@mui/material";
import { ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon } from "@mui/icons-material";
import { BACK, FOOTER_PRIVACY_POLICY } from "../../../modules/language";
import { fetchElencoProntoSoccorsoEnded, fetchPrivacyPsPolicyEnded, getPrivacyPsPolicy } from "../../../modules/prontoSoccorso";
import { Icona, LoadingSpinner } from "../../shared";
import { getMessageString } from "../../../utility";

export const Privacy = injectIntl(({ intl }) => {
  const navigate = useNavigate();
  const elencoPsEnded = useSelector(fetchElencoProntoSoccorsoEnded);
  const privacyPsPolicy = useSelector(getPrivacyPsPolicy);
  const privacyPsEnded = useSelector(fetchPrivacyPsPolicyEnded);

  return (
    <Box className="privacyPolicy">
      <Button startIcon={<ArrowBackIosNewOutlinedIcon />} onClick={() => navigate(-1)}>
        {getMessageString(intl, BACK)}
      </Button>
      <Stack className="pageTitle">
        <Icona tipologia="privacy" />
        <Typography variant="h2">{getMessageString(intl, FOOTER_PRIVACY_POLICY)}</Typography>
      </Stack>
      {privacyPsPolicy && <div dangerouslySetInnerHTML={{ __html: privacyPsPolicy }} />}
      <LoadingSpinner loading={!elencoPsEnded || !privacyPsEnded} />
    </Box>
  );
});
